"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _createOption = _interopRequireDefault(require("./createOption"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputArray/index.js";
var components = {
  DropdownIndicator: null
};
function InputArray(_ref) {
  var field = _ref.field,
    object = _ref.object;
  var _React$useState = _react["default"].useState((object[field] || []).map(_createOption["default"])),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    values = _React$useState2[0],
    setValues = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(''),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    value = _React$useState4[0],
    setValue = _React$useState4[1];
  function onChange(_values) {
    setValues(_values);
  }
  function onInputChange(value) {
    setValue(value);
  }
  function onKeyDown(e) {
    switch (e.key) {
      case 'Enter':
      case 'Tab':
        e.preventDefault();
        setValues([].concat((0, _toConsumableArray2["default"])(values), [(0, _createOption["default"])(value)]));
        setValue('');
        object[field] = values.map(function (v) {
          return v.value;
        });
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_creatable["default"], {
    components: components,
    inputValue: value,
    isClearable: true,
    isMulti: true,
    menuIsOpen: false,
    onChange: onChange,
    onInputChange: onInputChange,
    onKeyDown: onKeyDown,
    placeholder: "Type something and press enter...",
    value: values,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  });
}
var _default = InputArray;
exports["default"] = _default;